<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" v-bind:class="className">
      <div class="modal-overlay" @click="back()"></div>
      <div class="modal">
        <article v-if="resource">

          <header>
            <figure><i class="icon icon-icon_file-add"></i></figure>
            <div>
              <span class="breadcrumb">
                  Commande <i class="icon icon-icon_arrow-right"></i> New
              </span>
              <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
            </div>
            <div class="spacer"></div>
            <div class="buttons">
              <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
              <button @click="remove()" class="bt-primary bt-delete" v-if="resource.id"><span><i
                  class="icon icon-icon_delete"></i></span></button>
              <button @click="print()" class="bt-print" v-if="resource.invoice && resource.invoice.id"><span><i class="icon icon-printer"></i></span>
              </button>
              <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span>
              </button>
            </div>

            <div style="width: 100%;background: #ebedf3;padding: 10px;font-weight: 600;margin-bottom: 10px;display: flex;align-items: center;" v-if="!edition_mode">
              <div v-if="is_readonly"><i class="icon icon-icon_lock"></i> Cette commande est verouillée</div>
              <div v-if="is_readonly" style="margin-left: auto;font-size:12px;font-weight:400;background: #fff;padding: 5px 10px;cursor: pointer;" @click="forceActiveEditionMode">Forcer le dévérouillage</div>
              <div v-if="!is_readonly"><i class="icon icon-icon_lock-open"></i> Cette commande est verouillée, mais peut être éditée</div>
              <div v-if="!is_readonly" style="margin-left: auto;font-size:12px;font-weight:400;background: #fff;padding: 5px 10px;cursor: pointer;" @click="activeEditionMode">Déverouiller maintenant</div>
            </div>

            <div class="header-blocks">

              <div>
                <form-dropdown :options="shipping_types" v-model="resource.shipping_type" classes="big" label="Type de commande"></form-dropdown>
              </div>

              <div>
                <form-dropdown :options="payment_statuses" v-model="resource.new_payment_status" classes="big" label="Etat du paiement"></form-dropdown>
              </div>

              <div style="flex:1;" v-if="resource.shipping_type && order_statuses[resource.shipping_type]">

                <div class="form-field">
                  <div class="form-label">Etat de la commande</div>
                  <div class="form-input">

                    <div class="order-status-workflow" :class="resource.new_status">
                      <div class="order-status-workflow-container">
                    <span class="order-status-workflow-bar" :style="'width:'+((order_statuses[resource.shipping_type].length-1) * (100/(order_statuses[resource.shipping_type].length)))+'%;'">
                      <span class="order-status-workflow-bar-progress" :style="'width:'+order_status_progress+'%;'"></span>
                    </span>
                        <ul>

                          <li v-for="item in order_statuses[resource.shipping_type]" @click="setStatus(item.id)" :class="{'active': item.id == resource.new_status }">
                        <span class="order-status-workflow-dot">
                          <span><icon name="check"/></span>
                        </span>
                            <label>
                              <strong>{{ item.title }}</strong>
                              <p>{{ item.description }}</p>
                            </label>
                          </li>

                        </ul>
                      </div>
                    </div>

                  </div>
                </div>

                <form-checkbox label="Informer le client du changement" v-model="resource.has_notification"></form-checkbox>
              </div>
            </div>

              <!--
              <div class="order-steps" v-if="resource.invoice">
                <ul :class="resource.new_status">
                  <li class="payment"
                      v-bind:class="{'is-pending': resource.new_payment_status == 'pending', 'is-completed':resource.invoice.is_transaction_completed && resource.new_payment_status == 'completed'}">

                    <div v-bind:class="{'payed':resource.invoice.is_transaction_completed}">
                      <span>Paiement</span>
                      <i class="icon icon-order-success" v-if="resource.invoice.is_transaction_completed"></i>
                      <i class="icon icon-icon_close" v-if="!resource.invoice.is_transaction_completed"></i>
                    </div>

                  </li>
                  <li class="pending" @click="setStatus('pending')"
                      v-bind:class="{'is-completed': resource.is_payment_completed && (resource.new_payment_status == 'completed' || resource.new_payment_status == 'success'), 'is-pending': resource.new_payment_status == 'pending'}">
                    <span>En attente</span>
                    <i class="icon icon-icon_crate"></i>
                  </li>
                  <li class="in_progress" @click="setStatus('in_progress')"
                      v-bind:class="{'transporter': resource.is_transporter_informed > 0}">
                    <span>En traitement</span>
                    <i class="icon icon-order-success"></i>
                  </li>
                  <li class="terminated" @click="setStatus('terminated')" v-if="[null].indexOf(resource.shipping_type) >= 0">
                    <span>Terminé</span>
                    <i class="icon icon-order-success"></i>
                  </li>
                  <li class="shipped" @click="setStatus('shipped')" v-if="['shipping', 'delivery'].indexOf(resource.shipping_type) >= 0">
                    <span>Envoyé</span>
                    <i class="icon icon-order-success"></i>
                  </li>
                  <li class="delivered" @click="setStatus('delivered')" v-if="['pickup'].indexOf(resource.shipping_type) >= 0">
                    <span>Retrait</span>
                    <i class="icon icon-order-success"></i>
                  </li>
                </ul>
              </div>

            </div>
            -->

          </header>

          <tabs :options="{ useUrlFragment: false }">

            <tab name="Détail du client">

              <div class="tabs-component-panel-wrapper">
                <div>

                  <fieldset>
                    <h3>Client</h3>
                    <p class="headline"></p>

                    <entity v-model="entity" :default="resource.clientable_id" :default-type="resource.clientable_type"
                            :callback="updateEntity" :show-company="true" :show-detail="true" :show-create="true"
                            :disabled="!edition_mode" :required="true"></entity>

                    <group-line-2>
                      <form-text label="Email" v-model="resource.email"></form-text>
                      <form-text label="Téléphone fixe" v-model="resource.phone"></form-text>
                    </group-line-2>

                    <div class="address" v-show="entity">

                      <form-address
                          label="Adresse de facturation"
                          v-model="resource.address_billing"
                          :options="addresses" :required="true"></form-address>

                      <form-checkbox
                          v-if="['shipping', 'delivery'].indexOf(resource.shipping_type) >= 0"
                          label="Adresse de livraison identique"
                          v-model="resource.delivery_address_same_as_billing_address"
                          :callback="copyAddressBilling"></form-checkbox>

                      <br>

                      <form-address
                          v-if="['shipping', 'delivery'].indexOf(resource.shipping_type) >= 0 && !resource.delivery_address_same_as_billing_address"
                          label="Adresse de livraison"
                          v-model="resource.address_delivery"
                          :options="addresses" :required="true"></form-address>

                    </div>

                  </fieldset>

                </div>
                <aside>
                  <div>

                    <fieldset>
                      <h3>Détail</h3>
                      <p class="headline"></p>

                      <form-select-new label="Succursale" multiple="false" v-model="resource.branch" :default="resource.branch_id"
                                       :options="branches" v-if="branches" :required="true" :callback="selectBranch"></form-select-new>

                      <form-autocomplete label="Personne en charge" multiple="false" v-model="resource.user"
                                         :default="resource.user_id" :service="userService"
                                         icon="icon-icon_person" :required="true"></form-autocomplete>
                      <form-textarea label="Commentaire du client" v-model="resource.comment"></form-textarea>

                    </fieldset>

                  </div>
                </aside>
              </div>

            </tab>
            <tab name="Facture">


              <div class="tabs-component-panel-wrapper">
                <div>

                  <fieldset v-if="edition_mode !== true">
                    <h3>Détail de la facture</h3>
                    <p class="headline"></p>

                    <div class="invoice" v-if="resource.products && resource.products.length > 0 && edition_mode != true">
                      <div>

                        <invoice v-model="resource.invoice_details"
                                 :title="resource.invoice_title"
                                 :subtitle="resource.invoice_subtitle"
                                 :date="resource.invoiced_at"></invoice>

                      </div>
                    </div>

                  </fieldset>

                  <fieldset v-if="edition_mode == true">
                    <h3>Détail de la facture</h3>
                    <p class="headline"></p>

                    <span v-if="invoice.length <= 0">Votre facture est vide. Veuillez y ajouter des lignes.</span>

                    <div class="invoice-form" v-if="invoice.length > 0">

                      <div class="invoice-form-header">
                        <div class="first"></div>
                        <div class="name">Libellé</div>
                        <div class="quantity">Quantité</div>
                        <div class="price">Prix Brut {{ (is_ttc ? 'TTC' : 'HT') }}</div>
                        <div class="total">Total {{ (is_ttc ? 'TTC' : 'HT') }}</div>
                        <div class="last"></div>
                      </div>

                      <draggable v-model="invoice" @start="drag=true" @end="drag=false" :options="{handle:'.drag'}">
                        <div v-for="(value, index) in invoice" class="invoice-form-line">
                          <div class="invoice-form-line-item">

                            <div class="first">
                              <div class="drag">
                                <icon name="dots-grid"/>
                              </div>
                            </div>

                            <div class="name">
                              <input type="text" v-model="value.name" placeholder="Libellé"></input>
                            </div>

                            <div class="quantity">
                              <div class="field-group">
                                <input type="text" v-model="value.quantity"></input>
                                <label>{{ convertMetric(value.amount_metric_unit).suffix }}</label>
                              </div>
                            </div>

                            <div class="price">

                              <div class="field-group">
                                <label>{{ currency }}</label>
                                <input type="text" v-model="value.price_manual"></input>
                              </div>

                              <!-- 'Tarif ' + (is_ttc ? 'TTC' : 'HT') + (value.amount_metric_unit_value != 1 ? ' (pour ' + value.amount_metric_unit_value + ' ' + convertMetric(value.amount_metric_unit).suffix + ')' : '') -->
                            </div>

                            <div class="total">
                              <div class="price-format">
                                <span class="currency">{{ currency }}</span>
                                <span>{{ calculateItemTotal(value)|formatNumber }}</span>
                              </div>
                            </div>

                            <div class="last">
                              <button class="action-link" @click="removeRow(index)"><icon name="trash-01"/></button>
                            </div>
                          </div>

                          <div class="invoice-form-line-item">

                            <div class="first"></div>

                            <div class="name">
                              <textarea v-model="value.description" placeholder="Description"></textarea>
                            </div>

                            <div style="width: 30%;">
                              <div class="field-group">
                                <label>TVA</label>
                                <input type="text" v-model="value.price.tax"></input>
                                <div class="suffix">%</div>
                              </div>
                              <div class="field-group">
                                <label>Rabais</label>
                                <input type="text" v-model="value.discount" placeholder="0"></input>
                                <div class="suffix">%</div>
                              </div>
                            </div>

                            <div class="total" style="align-self: normal;">



                            </div>
                            <div class="last"></div>
                          </div>

                          <div class="invoice-form-line-item">

                            <div class="first"></div>

                            <div class="name" style="display: flex;">

                              <form-checkbox label="Le travail est au forfait" v-model="value.is_forfait"></form-checkbox>
                              <form-checkbox label="Définir comme rendez-vous" v-model="value.has_schedule"></form-checkbox>

                            </div>

                            <div class="last"></div>
                          </div>

                          <div class="invoice-form-line-item" v-if="value.has_schedule">

                            <div class="first"></div>

                            <div class="name" style="padding: 0.5em;">

                              <!--
                              <div v-for="schedule in value.schedules" style="font-size: 0.9em;margin-bottom: 0.5em;">
                                <schedule :start-at="schedule.start_at" :end-at="schedule.end_at"></schedule>
                              </div>
                              -->

                              <div v-for="schedule in value.schedule_details" style="font-size: 0.9em;margin-bottom: 0.5em;color:rgba(var(--color-main), 1);">
                                <schedule v-if="schedule" :start-at="schedule.schedule_start_at" :end-at="schedule.schedule_end_at"></schedule>
                              </div>
                              <div v-if="value.schedule_details && countEmptySchedules(value.schedule_details) > 0" style="color:rgba(var(--color-main), 1);font-weight:500;font-size:0.9em;">{{ countEmptySchedules(value.schedule_details) }} rendez-vous restant(s) à placer</div>

                            </div>

                            <div class="last"></div>
                          </div>

                          <div v-if="['shipping', 'delivery', 'pickup'].indexOf(resource.shipping_type) >= 0" class="invoice-line-delivery-notes">
                            <div v-for="(dn, index) in value.delivery_notes" :class="{'disabled':dn <= 0}">
                              <div style="margin-right: 10px;">
                                <icon name="package-check"/>
                              </div>
                              <div style="flex: 1;">
                                <strong style="font-weight: bold;">Bulletin de livraison</strong><br>
                                {{ resource.reference }}-{{ (index + 1).toString().padStart(2, '0') }}
                              </div>
                              <div>
                                <form-numeric
                                    label=""
                                    v-model="value.delivery_notes[index]"
                                    :default="value.delivery_notes[index]"
                                    :step="1"
                                    :width="100"></form-numeric>
                              </div>
                            </div>
                            <!--
                            <button @click="autoadjustDeliveryQuantity(value)" style="margin-left: auto;" class="invoice-line-delivery-notes-auto"><span>Répartir automatiquement les quantités</span></button>
                            -->
                          </div>

                        </div>
                      </draggable>
                    </div>

                    <ModalSearchProduct v-if="isModalSearchProductVisible"
                      @close="closeModalSearchProduct"
                      @validate="validateModalSearchProduct"/>

                    <div class="order-invoice-addlines" v-if="edition_mode == true" style="margin: 0; margin-top: 2em;">
                      <div class="" @click="addEmptyLine()"><icon name="plus-circle" /><span>Ajouter une ligne vierge</span></div>
                      <div class="" @click="searchProduct()"><icon name="search-sm" /><span>Ajouter un article du catalogue</span></div>
                    </div>

                  </fieldset>


                  <fieldset v-if="edition_mode == true">
                    <h3>Livraison</h3>
                    <p class="headline"></p>

                    <div style="display:flex;">
                      <div style="flex:1;">

                        <form-autocomplete placeholder="Coupon" v-model="voucher" :default="null"
                                           :service="voucherTokenService" :callback="selectVoucher"></form-autocomplete>

                        <div v-if="['shipping', 'delivery'].indexOf(resource.shipping_type) < 0">Le choix de la livraison n'est possible qu'en en mode "Livraison ou Expédition"</div>

                        <form-select-new placeholder="Livraison" v-model="shipping" :options="shippingListing"
                                         :callback="selectShipping"
                                         v-if="['shipping', 'delivery'].indexOf(resource.shipping_type) >= 0"></form-select-new>

                      </div>
                    </div>

                  </fieldset>

                </div>
                <aside>
                  <div>

                    <fieldset>
                      <h3>Détail du paiement</h3>
                      <p class="headline"></p>

                      <div>
                        <form-checkbox label="Saisie des valeurs en TTC" v-model="is_ttc" :callback="setTTC" v-if="edition_mode == true"></form-checkbox>
                        <form-checkbox label="Appliquer la TVA" v-model="resource.has_taxes" :callback="updateSubtotal" v-if="edition_mode == true"></form-checkbox>
                      </div>

                      <form-select-new label="Devise" multiple="false" v-model="resource.currency" :default="$store.state.scope.currency_id" :options="$store.state.currencies" :callback="setCurrency" :disabled="!edition_mode"></form-select-new>
                      <form-text label="Taux de conversion" v-model="resource.currency_conversion" :disabled="!edition_mode" v-show="currency != $store.state.scope.currency_id"></form-text>

                      <form-select-new label="Mode de paiement"
                                       multiple="false"
                                       v-model="payment"
                                       :options="payments"
                                       :required="true" :callback="setInvoicePayment"></form-select-new>

                      <div v-show="payment && payment.id && !payment.payment_onsite">
                        <form-select-new label="Conditions de paiement" multiple="false" v-model="payment_condition" :options="$store.getters.scope.payment_conditions" :required="true"></form-select-new>
                      </div>

                    </fieldset>

                    <fieldset>
                      <h3>Résumé</h3>
                      <p class="headline"></p>

                      <div class="invoice-table-footer">
                        <div class="subtotal" v-if="resource.amount_subtotal">
                          <div class="invoice-table-line">Sous-total {{ is_ttc ? "TTC" : "HT" }}</div>
                          <div class="invoice-table-line total" v-if="is_ttc"><span>{{
                              currency
                            }} {{ (resource.amount_subtotal + resource.amount_tax).toFixed(2) }}</span></div>
                          <div class="invoice-table-line total" v-if="!is_ttc"><span>{{
                              currency
                            }} {{ (resource.amount_subtotal).toFixed(2) }}</span></div>
                        </div>
                        <div class="voucher" v-if="voucher">
                          <div class="invoice-table-line">
                            {{ voucher.name }}
                          </div>
                          <div class="invoice-table-line">
                                <span>{{ currency }} - {{
                                    resource.amount_voucher ? resource.amount_voucher.toFixed(2) : 0
                                  }}</span>
                          </div>
                        </div>
                        <div class="shipping" v-if="shipping">
                          <div class="invoice-table-line">
                            {{ shipping.name }}
                          </div>
                          <div class="invoice-table-line">
                                <span>{{ currency }} {{ (resource.amount_shipping - 0).toFixed(2) }}</span>
                          </div>
                        </div>
                        <div class="tax" v-for="tax in resource.detail_taxes">
                          <div class="invoice-table-line">Taxes {{ tax.percentage }}% {{
                              is_ttc ? "incluse" : ""
                            }}
                          </div>
                          <div class="invoice-table-line">
                            <span>{{ currency }} {{ (tax.amount - 0).toFixed(2) }}</span>
                          </div>
                        </div>
                        <div class="total">
                          <div class="invoice-table-line">Total TTC en {{ currency }}</div>
                          <div class="invoice-table-line total">
                            <span>{{ currency }} {{ (resource.amount_total - 0).toFixed(2) }}</span>
                          </div>
                        </div>
                      </div>

                    </fieldset>

                  </div>
                </aside>
              </div>




            </tab>
            <tab name="Bulletin de livraison">

              <div v-if="resource && ['shipping', 'delivery', 'pickup'].indexOf(resource.shipping_type) >= 0">

                <div v-if="resource.delivery_notes && resource.delivery_notes.length">

                  <fieldset v-for="(item, index) in resource.delivery_notes" style="position: relative;">
                    <h3>Bulletin n°{{ resource.reference }}-{{ (index + 1).toString().padStart(3, '0') }}</h3>
                    <p class="headline">{{ item.shipping_type }}</p>

                    <button class="btn bt-outline" style="position: absolute; top: 0;
                    right:0;margin: calc(var(--gutter) * 2);" @click="printDelivery(resource.reference + '-' + (index + 1).toString().padStart(3, '0'))"><span>Imprimer le bulletin</span></button>

                    <group-line-2>
                      <form-datex label="Date d'émission" v-model="item.date_at" :hide-time="true" :disabled="!edition_shipped_mode"></form-datex>
                      <div style="gap: 1em;width:100%;display:flex;flex-direction:row;" class="tracking-url">
                        <form-text label="Numéro de suivi" placeholder="Tracking number (facultatif)" v-model="item.tracking_number" :disabled="!edition_shipped_mode"></form-text>
                        <div style="align-self: center;">
                          <a @click="getTrackingUrl(item.tracking_number)"
                             title="Tester l'url de tracking"
                             target="_blank"
                             style="display: inline-flex;">
                            <icon name="globe-06"/>
                          </a>
                        </div>
                      </div>
                    </group-line-2>

                    <!-- pour plus tard :-)
                    <form-address
                        label="Livraison"
                        v-model="item.address"
                        :options="addresses"></form-address>
                        -->


                    <div v-if="invoice" class="datagrid">
                      <div class="datagrid-header">
                        <div>
                          <div></div>
                          <div class="left"><span>Libellé</span></div>
                          <div class="center"><span>Quantité commandée</span></div>
                          <div class="center"><span>Quantité à livrer</span></div>
                          <div></div>
                        </div>
                      </div>
                      <div class="datagrid-body">
                        <div v-for="(invoiceItem, invoiceItemIndex) in invoice">
                          <div></div>
                          <div data-field="label" class="auto">
                            <strong class="highlight">{{ invoiceItem.name }}</strong>
                            <p class="address">{{ invoiceItem.description }}</p>
                          </div>
                          <div data-field="quantity" class="center">
                            <strong class="highlight">{{ invoiceItem.quantity }}</strong>
                          </div>
                          <div class="center">
                            <form-numeric
                                label=""
                                v-model="invoiceItem.delivery_notes[index]"
                                :step="1"
                                :width="100" :disabled="!edition_mode"></form-numeric>
                          </div>
                          <div></div>
                        </div>
                      </div>

                    </div>

                    <div style="display: flex;justify-content: center;gap: 1em;margin-top: 1em;" v-if="edition_mode">
                      <div>
                        <button @click="removeDeliveryNote(index)" style="margin-left: auto;" class="bt bt-delete">
                          <span>Supprimer le bulletin de livraison</span>
                        </button>
                      </div>
                    </div>

                  </fieldset>
                </div>

                <div style="display: flex;justify-content: center;gap: 1em;margin-top: 1em;" v-if="edition_mode">
                  <div>
                    <button @click="addDeliveryNote" class="bt bt-create">
                      <span>Ajouter un bulletin</span>
                    </button>
                  </div>
                  <div>
                    <button @click="autoadjustDeliveryQuantity(index)" style="margin-left: auto;" class="invoice-line-delivery-notes-auto bt bt-create">
                      <span>Répartir automatiquement les quantités</span>
                    </button>
                  </div>
                </div>



              </div>
              <div v-else>
                Votre facture ne contient pas de livraison, les bulletins sont donc inactifs
              </div>

            </tab>
            <tab name="Avancé">
              <fieldset>
                <h3>Facture</h3>
                <p class="headline"></p>


                <form-select-new label="Template"
                                 multiple="false"
                                 v-model="resource.invoice_template"
                                 :default="invoice_template_id"
                                 :options="templates"></form-select-new>

                <form-text label="Titre" v-model="resource.invoice_title" :disabled="!edition_mode"></form-text>
                <form-text label="Sous-titre" v-model="resource.invoice_subtitle" :disabled="!edition_mode"></form-text>
                <form-select label="Langue" multiple="false" v-model="resource.locale" :default="language"
                             :options="$store.state.locales"></form-select>
                <form-datex label="Date" v-model="resource.invoiced_at" :hide-time="true"
                            :disabled="!edition_mode"></form-datex>
                <form-text label="Reference" v-model="resource.reference" :disabled="true"></form-text>
                <form-text label="Purchase Number" v-model="resource.purchase_number"
                           :disabled="!edition_mode"></form-text>
                <form-textarea label="Commentaire et remarques" v-model="resource.invoice.comments_invoice"
                               hint="Les informations seront visibles en bas de la facture"
                               v-if="resource.invoice != null" :disabled="!edition_mode"></form-textarea>
              </fieldset>
            </tab>
          </tabs>

        </article>

      </div>
    </div>
  </transition>
</template>
<script>

import OrderService from './OrderService.js';
import Edit from '../../../layouts/Edit.vue';
import ProductService from '../../shop/product/ProductService.js';

import PaymentService from '../../config/payment/PaymentService.js';
import ShippingService from '../../shop/shipping/ShippingService.js';
import VoucherTokenService from '../../shop/voucher/VoucherTokenService.js';

import ScopeService from '../../scope/ScopeService.js';
import UserService from '../../scope/UserService.js';
import BranchService from "../../config/branch/BranchService";

import InvoiceTemplateService from '../../config/invoice-template/InvoiceTemplateService.js';
import ModalSearchProduct from '../../shop/product/ModalSearch.vue'

export default {
  extends: Edit,
  components: {
    ModalSearchProduct
  },
  data() {
    return {
      isModalSearchProductVisible: false,
      factor: 0.05,
      locale: null,
      voucher: null,
      shipping: null,
      payment: null,
      shipping_id: null,
      payments: [],
      shippingListing: [],
      productService: null,
      voucherTokenService: null,
      userService: null,
      product: null,
      price: null,
      currency: null,
      entity: null,
      branches: null,
      invoice: [],
      invoice_subtotal: 0,
      invoice_shipping: 0,
      invoice_taxes: 0,
      invoice_total: 0,
      addresses: [],
      has_shipping: false,
      invoice_template_id: null,
      types: [
        {id: 'person', name: 'Individu'},
        {id: 'company', name: 'Entreprise'}
      ],
      statuses: [
        {id: 'draft', name: 'Brouillon', color: '#888888'},
        {id: 'pending', name: 'En attente', color: '#f4b406'},
        {id: 'completed', name: 'Payé', color: '#46994e'},
        {id: 'canceled', name: 'Annulé', color: '#ba2766'}
      ],
      shipping_types: [
        {id:'invoice', title:'Facture simple', description: 'Facture de prestations uniquement', icon:'file-06'},
        {id:'shipping', title:'Envoi / expédition', description: 'Expédition à domicile via transporteur ou la poste', icon:'package'},
        {id:'delivery', title:'Livraison à domicile', description: 'Livraison à domicile le jour même', icon:'truck-01'},
        {id:'pickup', title:'Retrait en magasin', description: 'Retrait dans un magasin ou succursale', icon:'marker-pin-04'}
      ],
      payment_statuses: [
        {id:'draft', title:'Brouillon', icon:'placeholder', color: '#888888'},
        {id:'pending', title:'En attente', icon:'clock', color: '#f4b406'},
        {id:'completed', title:'Payé', icon:'check-circle', color: '#46994e'},
        {id:'canceled', title:'Annulé', icon:'x-circle', color: '#ba2766'},
      ],
      order_status_progress: 0,
      order_statuses: {
        'invoice': [
          {id:'pending', title:'En attente', description: 'Commande générée', icon:'file-06'},
          {id:'in_progress', title:'En traitement', description: 'Commande en traitement', icon:'package'},
          {id:'terminated', title:'Terminé', description: 'Commande terminée', icon:'truck-01'},
        ],
        'shipping': [
          {id:'pending', title:'En attente', description: 'Commande générée', icon:'file-06'},
          {id:'transporter_informed', title:'Transporteur', description: 'Le transporteur est informé', icon:'file-06'},
          {id:'in_progress', title:'En traitement', description: 'Commande en traitement', icon:'package'},
          {id:'shipped', title:'Envoyé', description: 'Commande envoyée au client', icon:'truck-01'},
        ],
        'delivery': [
          {id:'pending', title:'En attente', description: 'Commande générée', icon:'file-06'},
          {id:'in_progress', title:'En traitement', description: 'Commande en traitement', icon:'package'},
          {id:'delivered', title:'Envoyé', description: 'Commande envoyée au client', icon:'truck-01'},
        ],
        'pickup': [
          {id:'pending', title:'En attente', description: 'Commande générée', icon:'file-06'},
          {id:'in_progress', title:'En traitement', description: 'Commande en traitement', icon:'package'},
          {id:'prepared', title:'Prête', description: 'Commande prête à être retirée', icon:'bell-04'},
          {id:'picked_up', title:'Retiré', description: 'Commande retirée par le client', icon:'truck-01'},
        ],
      },
      //order_statuses: ['pending', 'in_progress', 'terminated', 'shipped', 'delivered'],
      updateSubtotalDebounce: null,
      product_id: null,
      indexStatus: null,
      resourceModal: null,
      language: null,
      branch_id: null,
      edition_mode: false,
      is_readonly: true,
      payment_condition: null,
      templates: null,
      is_ttc: null,
      debounceUpdateInvoice: null
    }
  },
  mounted: function () {

    let self = this;

    this.resourceModal = this.resource || {};
    this.price = 'HT'

    this.initServices();

  },
  methods: {
    selectBranch: function(item, status){

      let currentTemplateId = this.resource.invoice_template ? this.resource.invoice_template.id : null;

      //alert(this.resource.branch.id + " " + this.branch_id)

      if( item && item.invoice_template_id && this.branch_id != item.id ){

        if( currentTemplateId !== null && currentTemplateId !== undefined && currentTemplateId != item.invoice_template_id ){
          let ask = confirm("La succursale a changé, souhaitez-vous adapter le template de la facture ?");
          if( ask ){
            this.selectInvoiceTemplate(item.invoice_template_id)
          }
        }else{
          this.selectInvoiceTemplate(item.invoice_template_id)
        }
      }

      this.branch_id = item.id || null;
    },
    selectInvoiceTemplate:function(id){
      let self = this;
      if( id && this.templates ){
        this.templates.forEach(function(item){
          if( id == item.id ){
            self.resource.invoice_template = item;
          }
        });
      }
      this.$forceUpdate()
    },
    initServices: function(){

      this.productService = ProductService;
      this.voucherTokenService = VoucherTokenService;
      this.userService = UserService;

      this.product_id = this.resource.product ? this.resource.product.id : null

      this.countries = {}
      for (let item of this.$store.state.countries) {
        this.countries[item.id] = item
      }

      InvoiceTemplateService.all().then(response => {
        this.templates = response.data
        this.isLoading = false
      });

      PaymentService.all().then(response => {
        this.payments = response.data
        this.isLoading = false
      });

      BranchService.query().then(response => {
        this.branches = response.data.data;
        this.isLoading = false
      });
    },
    countEmptySchedules: function(schedules){

      if( schedules ){
        let count = 0;
        for (let item of schedules) {
          if( item === null ){
            count+=1;
          }
        }
        return count;
      }
      return 0;
    },
    test: function(){
      this.resource.new_payment_status = 'draft';
      this.$forceUpdate();
    },
    closeModalSearchProduct: function(){
      this.isModalSearchProductVisible = false;
    },
    validateModalSearchProduct: function(item){
      this.isModalSearchProductVisible = false;
      if( item )
      {
        this.addProductLine(item, true);
      }
    },
    searchProduct: function(){
      this.isModalSearchProductVisible = true;
    },
    setInvoicePayment: function(item){
      if( item && item.id )
      {
        this.setDefaultPaymentCondition();
      }
    },
    setDefaultPaymentCondition: function(){
      /*
       * Define payment deadline per default
       */
      let payment_condition_id = this.payment_condition && this.payment_condition.id ? this.payment_condition.id : null;
          payment_condition_id = payment_condition_id == null ? ((this.resource.invoice && this.resource.invoice.payment_condition_id) ? this.resource.invoice.payment_condition_id : null) : payment_condition_id;
          payment_condition_id = payment_condition_id == null ? this.$store.getters.scope.payment_condition_id : payment_condition_id;

      this.resource.payment_condition = null;
      this.$store.state.scope.payment_conditions.forEach((item) => {
        if( item.id == payment_condition_id )
        {
          this.payment_condition = item;
        }
      })

    },
    setCurrency: function(item){
      this.currency = item.id

      let oldRate = this[('currency_conversion_' + this.currency).toLowerCase()] ? this[('currency_conversion_' + this.currency).toLowerCase()] : null
      if( oldRate )
      {
        this.resource.currency_conversion = oldRate
      }else{
        // Get a new rate
        ScopeService.getCurrencyConversion(this.currency).then(response => {
          this.resource.currency_conversion = response.data.rate
          this.isLoading = false
          this.$forceUpdate()
        });
      }

    },
    convertMetric: function(id){
      let metric = null;
      for (let item of this.$store.state.metrics) {
        if (item.id == id) {
          metric = item;
          break;
        }
      }
      return metric;
    },
    changeToForfait: function(){
      this.$forceUpdate()
    },
    print: function () {
      window.open(this.resource.invoice.download_link, 'Download Invoice');
    },
    printDelivery: function (id) {

      let link = this.resource.invoice.download_link + "?delivery_note=" + id;

      let ask = confirm("L'impression nécessite un enregistrement, souhaitez-vous continuer ?")
      if(ask){
        this.submit(function(){
          window.open(link, 'Download Delivery');
        });
      }
    },
    setTTC: function (args) {
      this.updateSubtotal();
    },
    updateDeliveryNote: function(){
      let self = this;
      this.invoice.forEach(function(item){
        let quantity = item['has_' + self.resource.shipping_type] !== undefined && item['has_' + self.resource.shipping_type] ? item.quantity : 0;
        console.log("updateDeliveryNote", 'has_' + self.resource.shipping_type, item.delivery_notes.length)

        if( item.delivery_notes.length == 1 )
        {
          item.delivery_notes.splice(0, 1);
        }
        if( item.delivery_notes.length < 1 )
        {
          item.delivery_notes.push(quantity);
          console.log("updateDeliveryNote", "quantity => " + quantity)
        }

      });

      this.$forceUpdate()
    },
    addDeliveryNote: function()
    {

      this.resource.delivery_notes.push({
        id: null,
        date_at: this.resource.invoice ? this.resource.invoice.invoice_at : null,
        address: this.resource.address_delivery || this.resource.address_billing || null,
        tracking_number: null,
        comment: null,
      });

      this.updateDeliveryNote();

    },
    removeDeliveryNote: function(index)
    {
      let ask = confirm("Etes-vous certain de vouloir supprimer ce bulletin ?");
      if( ask ){
        this.resource.delivery_notes.splice(index, 1);

        this.invoice.forEach(function(item){
          item.delivery_notes.splice(index, 1);
        });
      }

    },
    updateDelivery: function () {
      this.$forceUpdate();
    },
    addProductLine: function (item, newProduct) {

      let found = false;

      this.product_id = null;
      this.product = null;
      this.$forceUpdate()

      if (item && (item.price || item.calculation) && !found) {

        let is_forfait = item.is_forfait || false
        let amount_metric_unit = item.amount_metric_unit ? item.amount_metric_unit : 'unit'
        let amount_metric_unit_value = item.amount_metric_unit_value
        let quantity = item.quantity ? item.quantity : item.amount_metric_unit_value
        let price_manual = 0

        let price_flat = item.price && item.price.flat ? item.price.flat : item.price;

        if (this.is_ttc) {
          //price_manual = (item.price.flat.ttc / (quantity/amount_metric_unit_value));
          price_manual = price_flat.ttc || item.price.ttc;
        } else {
          //price_manual = (item.price.flat.ht / (quantity/amount_metric_unit_value));
          price_manual = price_flat.ht || item.price.ht;
        }

        if( newProduct )
        {
          price_manual = price_manual / item.amount_metric_unit_value;
        }

        let discount = item.discount || 0;
        /*
        if( price_manual != item.price.ht )
        {
          discount = 100 - (item.price.ht * 100 / (price_flat.ht || item.price.ht));
        }

        discount = discount <= 0 ? 0 : discount;
         */

        let delivery_notes = [];
        this.resource.delivery_notes.forEach(function(dn, index){
          let qty = 0;
          if( dn.delivery_note_items && dn.delivery_note_items[item.order_product_id] )
          {
            qty = dn.delivery_note_items[item.order_product_id]
          }
          delivery_notes.push( qty )
        });

        this.invoice.push({
          order_product_id: item.order_product_id || null,
          id: item.id || null,
          name: item.name,
          description: item.headline || item.description,
          is_service: item.is_service,
          sku: item.sku,
          ean: item.ean,
          picture: item.picture,
          quantity: quantity,
          is_forfait: is_forfait,
          has_schedule: item.has_schedule ? true : false,
          has_shipping: item.has_shipping ? true : false,
          has_delivery: item.has_delivery ? true : false,
          has_pickup: item.has_pickup ? true : false,
          schedules: item.schedules || null,
          schedule_details: item.schedule_details || null,
          amount_metric_unit_value: amount_metric_unit_value,
          amount_metric_unit: amount_metric_unit,
          price_manual: price_manual.toFixed(2),
          price_manual_with_discount: price_manual.toFixed(2),
          price: item.price,
          discount: discount,
          delivery_notes: delivery_notes
        });
      }

      //this.updateSubtotal()
      this.product = null;
    },
    getDefaultQuantityForItemId: function(index, id){
      //console.log("getDefaultQuantityForItemId", index, id, this.resource.delivery_notes[index].delivery_note_items)
      if( id && this.resource.delivery_notes && this.resource.delivery_notes[index] && this.resource.delivery_notes[index].delivery_note_items && this.resource.delivery_notes[index].items && this.resource.delivery_notes[index].items[id] )
      {
        //console.log("---> found", this.resource.delivery_notes[index].delivery_note_items[id])
        return this.resource.delivery_notes[index].delivery_note_items[id];
      }
      return 0;
    },
    removeRow: function (index) {
      let ask = confirm("Etes-vous sûr de vouloir supprimer cet article ?")
      if( ask )
      {
        this.invoice.splice(index, 1)
      }
    },
    addEmptyLine: function () {

      let percentage = 0;
      for (let tax of this.$store.state.taxes) {
        if( this.$store.state.scope.default_tax_id == tax.id )
        {
          percentage = tax.percentage;
          break;
        }
      }

      this.invoice.push({
        order_product_id: null,
        id: null,
        name: "",
        description: null,
        sku: null,
        ean: null,
        picture: null,
        is_service: false,
        quantity: 1,
        is_forfait: false,
        has_delivery: false,
        schedules: null,
        schedule_details: null,
        amount_metric_unit: 'unit',
        amount_metric_unit_value: 1,
        price_manual: 0,
        price_manual_with_discount: 0,
        price: {
          ht: 0,
          ttc: 0,
          flat: {
            ht: 0,
            ttc: 0,
          },
          tax: percentage
        },
        product: null,
        discount: null,
        delivery_notes: Array(this.resource.delivery_notes.length).fill(0)
      });

      //this.updateSubtotal()
    },
    calculateItemTotal: function (item) {
      let total = 0
      if (item.discount) {
        total = parseFloat(item.price_manual - (item.price_manual * item.discount / 100))
      } else {
        total = parseFloat(item.price_manual);
      }

      if (this.is_ttc) {
        //total = parseFloat(item.price_manual_with_discount / (1+(item.price.tax/100)));
      }

      return total * item.quantity
      //return total * (item.quantity / item.amount_metric_unit_value)
    },
    updateSubtotal: function () {

      let self = this

      if (this.initialized) {

        if (this.edition_mode != true) {
          return true;
        }

        clearInterval(this.updateSubtotalDebounce)

        this.updateSubtotalDebounce = setTimeout(function () {

          let invoice = self.copy(self.invoice)

          for (let item of invoice) {
            if (item.discount) {
              item.price_manual_with_discount = parseFloat(item.price_manual - (item.price_manual * item.discount / 100))
            } else {
              item.price_manual_with_discount = parseFloat(item.price_manual);
            }

            if (self.is_ttc) {
              item.price_manual_with_discount = parseFloat(item.price_manual_with_discount / (1 + (item.price.tax / 100)));
            }

            let price_ht = !self.is_ttc ? item.price_manual_with_discount : item.price_manual_with_discount / (1 + (item.price.tax / 100));
            let price_ttc = self.is_ttc ? item.price_manual_with_discount : item.price_manual_with_discount * (1 + (item.price.tax / 100));

            let price_flat_ht = !self.is_ttc ? item.price_manual : item.price_manual / (1 + (item.price.tax / 100));
            let price_flat_ttc = self.is_ttc ? item.price_manual : item.price_manual * (1 + (item.price.tax / 100));

            item.price.ht = parseFloat(price_ht);
            item.price.ttc = parseFloat(price_ttc);
            if( item.price.flat === undefined )
            {
              item.price.flat = {};
            }
            item.price.flat.ht = parseFloat(price_flat_ht);
            item.price.flat.ttc = parseFloat(price_flat_ttc);

          }

          let country = null;
          if( self.resource.address_delivery && self.resource.address_delivery.country && self.resource.address_delivery.country.id !== undefined ){
            country = self.resource.address_delivery.country.id;
          }else if( self.resource.address_delivery && self.resource.address_delivery.country !== undefined ){
            country = self.resource.address_delivery.country;
          }

          OrderService.calculate({
            has_taxes: self.resource.has_taxes,
            products: invoice,
            voucher: self.voucher,
            country: country,
            currency: self.currency,
            shipping_id: self.shipping_id,
            invoice_payment_id: self.payment ? self.payment.id : null,
            allowed_shipping_types: [self.resource.shipping_type]

          }).then(response => {

            if( response.data )
            {
              self.resource.amount_shipping = response.data.amount_shipping
              self.resource.amount_tax = response.data.amount_tax
              self.resource.amount_subtotal = response.data.amount_subtotal
              self.resource.amount_total = response.data.amount_total
              self.resource.amount_voucher = response.data.amount_voucher

              self.resource.detail_total = response.data.detail_total
              self.resource.detail_taxes = response.data.detail_taxes
              self.resource.detail_shipping = response.data.detail_shipping
              self.resource.detail_products = response.data.detail_products
              self.resource.detail_vouchers = response.data.detail_vouchers

              self.resource.has_shipping = response.data.has_shipping
              self.resource.has_schedule = response.data.has_schedule

              self.shippingListing = response.data.methods.shipping
              self.shipping = response.data.detail_shipping
            }
            self.$forceUpdate()

          })

        }, 100)


      }

    },
    selectVoucher: function (item) {
      //this.voucher_id = item.id
      this.updateSubtotal();
    },
    selectShipping: function (item) {

      if (item && item.id) {
        this.shipping_id = item.id
      } else {
        this.shipping_id = null
      }

      this.updateSubtotal();
      return true;

      if (this.resource.detail_shipping && this.resource.detail_shipping.id && this.resource.detail_shipping.id == this.shipping_id) {
        // Do nothing
        this.updateSubtotal();
      } else {
        this.updateSubtotal();
      }

    },
    updateAddress: function (item) {

      console.log("updateAddress", item, this.resource.address_billing)

    },
    updateEntity: function (item) {

      if (item && item.entity) {

        //console.log('ENTITY', item.entity)

        this.resource.clientable_id = item.entity.id
        this.resource.clientable_type = item.type
        this.addresses = item.addresses

        this.resource.email = item.entity.email ? item.entity.email : this.resource.email
        this.resource.phone = item.entity.phone_mobile ? item.entity.phone_mobile : this.resource.phone

        if (item.addresses[0] && (this.resource.address_billing == null || this.resource.address_billing == {})) {
          if (this.resource.id == null) {
            this.resource.address_billing = item.addresses[0];
            if( this.resource.delivery_address_same_as_billing_address ){
              this.resource.address_delivery = item.addresses[0];
            }
          }
        }

      } else {
        this.resource.client = null
      }

    },
    setShipping: function (item) {
      this.updateSubtotal();
    },
    resourceLoaded: function () {
      var today = new Date()

      this.resource.invoiced_at = this.resource.invoice && this.resource.invoice.invoiced_at ? this.resource.invoice.invoiced_at : today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      this.resource.user_id = this.resourceModal.user_id || this.resource.user_id || this.$store.state.user.id;
      this.resource.old_status = this.resourceModal.order_status || this.resource.order_status || 'pending';
      this.resource.clientable_id = this.resourceModal.clientable_id || this.resource.clientable_id || null;
      this.resource.clientable_type = this.resourceModal.clientable_type || this.resource.clientable_type || null;
      this.resource.branch_id = this.resourceModal.branch_id || this.resource.branch_id || null;
      this.branch_id = this.resource.branch_id;
      this.resource.schedule = this.resourceModal.schedule || null;
      this.language = this.resourceModal.language || this.resource.language || 'fr';

      this.resource.delivery_notes = this.resource.delivery_notes ? this.resource.delivery_notes : [];

      //this.resource.shipping_type = this.resource.shipping_type ? this.resource.shipping_type : "invoice";

      this.resource.email = this.resource.email || null;
      this.resource.phone = this.resource.phone || null;

      this[('currency_conversion_' + this.resource.currency).toLowerCase()] = this.resource.currency_conversion || null

      this.invoice_template_id = this.resource.invoice && this.resource.invoice.invoice_template_id ? this.resource.invoice.invoice_template_id : null

      this.setDefaultPaymentCondition();

      this.resource.detail_shipping = this.resource.detail_shipping || null;
      this.resource.detail_payment = this.resource.detail_payment || null;

      this.resource.detail_products = this.resource.detail_products || [];
      this.resource.detail_vouchers = this.resource.detail_vouchers || [];

      this.resource.new_payment_status = this.resourceModal.payment_status || (this.resource.invoice ? this.resource.invoice.payment_status : null) || this.resource.payment_status || 'draft';
      this.resource.shipping_type = this.resource.shipping_type ? this.resource.shipping_type : "invoice";

      this.resource.has_taxes = this.resource.invoice && this.resource.invoice.has_taxes ? true : false;
      //this.resource.branch = this.resource.branch || this.resource.branch_id;

      this.resource.address_billing = this.resource.invoice ? this.resource.invoice.address_billing : null;
      this.resource.address_delivery = this.resource.address_delivery || null;

      this.resource.status = this.resource.status ? this.resource.status : [];
      this.resource.has_notification = false;
      this.resource.has_shipping = this.resource.has_shipping != null ? this.resource.has_shipping : this.has_shipping;

      this.voucher = (this.resource && this.resource.detail_vouchers && this.resource.detail_vouchers[0]) || null;

      this.shipping_id = this.resource.detail_shipping && this.resource.detail_shipping.id ? this.resource.detail_shipping.id : null

      this.shipping = this.resource.detail_shipping
      this.payment = this.resource.invoice ? this.resource.invoice.detail_payment : null

      //this.resource.new_status = this.resource.old_status;
      //this.indexStatus = this.order_statuses.indexOf(this.resource.new_status);
      this.is_readonly = this.resource.invoice ? this.resource.invoice.is_readonly : 0

      this.setStatus(this.resource.old_status);

      this.resource.invoice_title = this.resource.invoice ? this.resource.invoice.title : null
      this.resource.invoice_subtitle = this.resource.invoice ? this.resource.invoice.subtitle : null

      this.resource.amount_shipping = this.resource.amount_shipping || 0
      this.resource.amount_tax = this.resource.amount_tax || 0
      this.resource.amount_subtotal = this.resource.amount_subtotal || 0
      this.resource.amount_total = this.resource.amount_total || 0
      this.resource.amount_voucher = this.resource.amount_voucher || 0

      this.is_ttc = this.resource.invoice ? this.resource.invoice.is_ttc : this.$store.state.scope.is_ttc


      if( this.resourceModal && this.resourceModal.product && this.resourceModal.product.id )
      {

        this.productService.get(this.resourceModal.product.id).then(response => {
          if (response) {
            if( this.resourceModal.schedule ){
              response.data.schedules = [{
                id: this.resourceModal.schedule.id,
                start_at: this.resourceModal.schedule.start_at,
                end_at: this.resourceModal.schedule.end_at
              }];

              response.data.schedule_details = [{
                schedule_id: this.resourceModal.schedule.id,
                schedule_start_at: this.resourceModal.schedule.start_at,
                schedule_end_at: this.resourceModal.schedule.end_at
              }];
            }
            this.addProductLine(response.data, true);
          }
        })

      }


      if( this.resource.products )
      {
        // Items exists
        for (let item of this.resource.products) {

          item.amount_ht -= 0;
          item.amount_base_ht -= 0;
          item.tax_percentage -= 0;

          if( item.parent_id == null )
          {

            let delivery_notes = [];
            this.resource.delivery_notes.forEach(function(dn, index){
              let qty = 0;
              if( dn.delivery_note_items && dn.delivery_note_items[item.id] )
              {
                qty = dn.delivery_note_items[item.id]
              }
              delivery_notes.push( qty )
            });

            this.addProductLine({
              order_product_id: item.id,
              id: item.original_product_id,
              quantity: item.quantity,
              is_forfait: item.is_forfait,
              amount_metric_unit: item.amount_metric_unit,
              amount_metric_unit_value: item.amount_metric_unit_value,
              name: item.name,
              description: item.description,
              sku: item.original_product.sku || null,
              ean: item.original_product.ean || null,
              has_schedule: item.has_schedule ? true : false,
              has_shipping: item.has_shipping ? true : false,
              has_delivery: item.has_delivery ? true : false,
              has_pickup: item.has_pickup ? true : false,
              schedules: item.schedules || null,
              schedule_details: item.schedule_details || null,
              is_service: item.original_product.is_service,
              discount: item.discount_percentage,
              picture: item.original_product.picture,
              price: {
                ht: item.amount_ht,
                ttc: (item.amount_ht + item.amount_tax),
                flat: {
                  ht: item.amount_base_ht || item.amount_ht,
                  ttc: (item.amount_base_ht || item.amount_ht) * (1 + (item.tax_percentage/100)),
                },
                tax: item.tax_percentage
              },
              delivery_notes: delivery_notes,
            })
          }

        }
      }

      if (this.resource.id == null) {
        this.edition_mode = true;
        this.is_readonly = false;
        this.resource.has_taxes = true;
      }

      if (this.resource.invoice && this.resource.invoice.payment_status === 'draft') {
        this.edition_mode = true;
        this.is_readonly = false;
      }

      this.resource.delivery_address_same_as_billing_address = this.addressBillingFlatten === this.addressDeliveryFlatten;

      this.initialized = true

      setTimeout(this.updateSubtotal, 1000)
      this.initialize()
    },
    beforeUpdate: function (Resource) {

      //Resource.locale = Resource.locale && Resource.locale.id ? Resource.locale.id : null;
      //Resource.detail_products = this.invoice;
      //Resource.client_type = Resource.client_type instanceof Array ? Resource.client_type[0] : Resource.client_type;

      Resource.detail_shipping = this.shipping ? this.shipping : null
      Resource.detail_payment = this.payment ? this.payment : null
      Resource.force_edition = this.edition_mode
      Resource.payment_condition = this.payment_condition
      Resource.is_ttc = this.is_ttc


      if (Resource.old_status != Resource.new_status && ['shipped', 'in_progress', 'delivered'].indexOf(Resource.new_status) >= 0 &&
          Resource.has_notification == false) {
        let confirmMessage = confirm("Souhaitez-vous changer le statut sans notifier le client ?")
        if (!confirmMessage) {
          return false;
        }
      }

      return true;
    },
    copyAddressBilling:function(value){
      if( value )
      {
        this.resource.address_delivery = this.copy(this.resource.address_billing);
      }
      this.$forceUpdate()
    },
    getResource: function () {
      return OrderService
    },
    getTrackingUrl: function (trackingNumber) {

      if (this.resource && this.resource.detail_shipping && this.resource.detail_shipping.transporter && this.resource.detail_shipping.transporter.tracking_url && trackingNumber) {

        let lang = this.resource.language || "";
        let countryId = (this.resource.address_delivery && this.resource.address_delivery.country && this.resource.address_delivery.country.id ? this.resource.address_delivery.country.id : (this.resource.address_delivery.country_id ? this.resource.address_delivery.country_id : "")).toLowerCase();

        let url = this.resource.detail_shipping.transporter.tracking_url
            .replace(/#number#/i, trackingNumber)
            .replace(/#lang#/i, lang.toLowerCase())
            .replace(/#country#/i, countryId)
            .replace(/#locale#/i, countryId + "_" + lang.toLowerCase())

        window.open(url);
      }
      if( !trackingNumber ){
        alert("Veuillez saisir un numéro de suivi")
      }

      return null
    },
    setStatus: function (status) {
      //this.indexStatus = this.order_statuses.indexOf(status)

      let progress = 0;

      //alert(this.resource.shipping_type + " - " + status)

      if( this.order_statuses[this.resource.shipping_type] ){

        let statusExists = false;
        for(let index in this.order_statuses[this.resource.shipping_type]){
          if( this.order_statuses[this.resource.shipping_type][index].id == status ){
            statusExists = status;
            break;
          }
        }

        if( statusExists !== false ){
          this.resource.new_status = statusExists
        }else{
          this.resource.new_status = this.order_statuses[this.resource.shipping_type][0].id
        }

        for(let index in this.order_statuses[this.resource.shipping_type]){
          if( this.order_statuses[this.resource.shipping_type][index].id == this.resource.new_status ){
            progress = (index * 100) / (this.order_statuses[this.resource.shipping_type].length - 1);
            break;
          }
        }

      }

      this.order_status_progress = progress;

      this.$forceUpdate()
    },
    forceActiveEditionMode: function () {
      let self = this;
      if (this.resource.id != null && this.is_readonly ) {

        OrderService.unsetReadonly(this.resource.id).then(response => {
          self.edition_mode = true;
          self.$forceUpdate();
        });

      } else {
        alert("La facture ne peut pas être déverouillée car elle a été payée.")
      }
    },
    activeEditionMode: function () {
      if (this.resource.id != null && !this.is_readonly ) {
        this.edition_mode = true;
        this.$forceUpdate();
      } else {
        alert("La facture est verouillée car elle a été payée.")
      }

      /*
      if (this.resource.id != null && this.resource.new_payment_status !== "completed" && this.resource.is_readonly != true && !this.is_readonly ) {
        this.edition_mode = true;
        this.$forceUpdate();
      } else {
        alert("La facture est verouillée car elle a été payée.")
      }
      */
    },
    updateDeliveryNotes: function(){
      if( ['shipping', 'delivery', 'pickup'].indexOf(this.resource.shipping_type) >= 0 )
      {
        if( this.resource.delivery_notes && this.resource.delivery_notes.length <= 0 ) {
          this.addDeliveryNote();
        }
      }
    },
    /*
    autoadjustDeliveryQuantity: function (item) {

      let quantite = item.quantity
      let nombreLivraisons = this.resource.delivery_notes.length

      const quantiteParLivraison = Math.floor(quantite / nombreLivraisons);
      const quantiteRestante = quantite % nombreLivraisons;
      const resultats = Array(nombreLivraisons).fill(quantiteParLivraison);

      for (let i = 0; i < quantiteRestante; i++) {
        resultats[i]++;
      }

      item.delivery_notes = resultats;
    }*/
    autoadjustDeliveryQuantity: function (index) {

      let self = this;

      this.invoice.forEach(function(item){
        let quantite = item.quantity
        let nombreLivraisons = self.resource.delivery_notes.length

        const quantiteParLivraison = Math.floor(quantite / nombreLivraisons);
        const quantiteRestante = quantite % nombreLivraisons;
        const resultats = Array(nombreLivraisons).fill(quantiteParLivraison);

        for (let i = 0; i < quantiteRestante; i++) {
          resultats[i]++;
        }

        item.delivery_notes = resultats;
      })

    }
  },
  computed: {
    edition_shipped_mode() {
      let edit = this.resource.old_status == "shipped" ? false : true;
      edit = this.edition_mode ? true : edit;
      return edit;
    },
    addressBillingFlatten() {
      let flatten = [];
      let address = this.resource.address_billing || {};
      if( address.company !== undefined ){ flatten.push(address.company); }
      if( address.firstname !== undefined ){ flatten.push(address.firstname); }
      if( address.lastname !== undefined ){ flatten.push(address.lastname); }
      if( address.street !== undefined ){ flatten.push(address.street); }
      if( address.street_number !== undefined ){ flatten.push(address.street_number); }
      if( address.street_complement !== undefined ){ flatten.push(address.street_complement); }
      if( address.locality !== undefined ){ flatten.push(address.locality); }
      if( address.postal_code !== undefined ){ flatten.push(address.postal_code); }
      return JSON.stringify(flatten.join('_')).toLowerCase();
    },
    addressDeliveryFlatten() {
      let flatten = [];
      let address = this.resource.address_delivery || {};
      if( address.company !== undefined ){ flatten.push(address.company); }
      if( address.firstname !== undefined ){ flatten.push(address.firstname); }
      if( address.lastname !== undefined ){ flatten.push(address.lastname); }
      if( address.street !== undefined ){ flatten.push(address.street); }
      if( address.street_number !== undefined ){ flatten.push(address.street_number); }
      if( address.street_complement !== undefined ){ flatten.push(address.street_complement); }
      if( address.locality !== undefined ){ flatten.push(address.locality); }
      if( address.postal_code !== undefined ){ flatten.push(address.postal_code); }
      return JSON.stringify(flatten.join('_')).toLowerCase();
    }
  },
  watch: {
    'invoice': {
      handler: function (newVal, oldVal) {
        clearTimeout(this.debounceUpdateInvoice);
        this.debounceUpdateInvoice = setTimeout(this.updateSubtotal, 500);
      },
      deep: true
    },
    'resource.shipping_type': {
      handler: function (newVal, oldVal) {
        this.setStatus(this.resource.new_status);
        this.updateDeliveryNotes();
      },
      deep: false
    },
    'resource.address_billing': {
      handler: function (newVal, oldVal) {
        console.log("$watch resource.address_billing", newVal)
        if( this.resource.delivery_address_same_as_billing_address )
        {
          this.copyAddressBilling(true)
        }
      },
      deep: true
    },
    'resource.address_delivery': {
      handler: function (newVal, oldVal) {
        console.log("$watch resource.address_delivery", newVal)
        this.updateSubtotal();
      },
      deep: true
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/shop/order/Edit.vue